import { render, staticRenderFns } from "./mobile-noteoriginal.vue?vue&type=template&id=74817513&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./mobile-noteoriginal.vue?vue&type=script&lang=js&"
export * from "./mobile-noteoriginal.vue?vue&type=script&lang=js&"
import style0 from "./mobile-noteoriginal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports